<template>
  <div class="form-success form-failure">
    <div class="home-logo">
      <img :src="siteData.urlLogo" :style="siteData.stylesLogo">
    </div>
    <h1>{{ $t('formFailure.title') }}</h1>
    <p v-html="failureContent"></p>
  </div>
</template>

<script>
import asyncLoading from './mixins/asyncLoading'
import localeHandler from './mixins/localeHandler'

export default {
  mixins: [ localeHandler, asyncLoading ],
  computed: {
    failureContent: {
      get () {
        return this.$t('formFailure.content', { email: this.siteData.email, url: '/' + this.locale + '/' + this.fromSite })
      }
    }
  }
}
</script>

<style>
.home-logo {
  text-align: center;
  max-width: 100%;
}
.form-success.form-failure a{
  color: #717171;
}
</style>
